import React from 'react'
import { useSelector } from 'react-redux';

import TextPlane from './TextPlane'

// Mostra i numeri dei lati sulla griglia di base
export default function BaseDirections() {
    const lunghezza = useSelector(state => state.uiMainMenu.lunghezza);
    const larghezza = useSelector(state => state.uiMainMenu.larghezza);
    const offset = 0.5;

    return (
        <>
            <TextPlane text={1} position={[-lunghezza / 2 - offset, .01, 0]} />
            <TextPlane text={2} position={[0, .01, -larghezza / 2 - offset]} />
            <TextPlane text={3} position={[lunghezza / 2 + offset, .01, 0]} />
            <TextPlane text={4} position={[0, .01, larghezza / 2 + offset]} />
        </>
    )
}
